import React from "react";
import { Line, Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    BarElement,
} from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Filler, Tooltip, Legend, BarElement);

const CategoryRevenueChart = ({ categoriesRevenueData}) => {
    const data = {
        labels: categoriesRevenueData.map(item => item.categoryName),
        datasets: [
            {
                label: 'Doanh thu (VND)',
                data: categoriesRevenueData.map(item => item.revenue), // Doanh thu tương ứng từng thể loại
                backgroundColor: [
                    'rgba(255, 99, 132, 0.4)',
                    'rgba(54, 162, 235, 0.4)',
                    'rgba(255, 206, 86, 0.4)',
                    'rgba(75, 192, 192, 0.4)',
                    'rgba(153, 102, 255, 0.4)',
                    'rgba(255, 159, 64, 0.4)', // Cam sáng
                    'rgba(128, 0, 128, 0.4)',  // Tím đậm
                    'rgba(0, 128, 128, 0.4)',  // Xanh lục lam
                    'rgba(255, 255, 0, 0.4)',  // Vàng
                    'rgba(0, 255, 255, 0.4)',  // Xanh dương sáng
                    'rgba(128, 128, 128, 0.4)', // Xám
                    'rgba(240, 248, 255, 0.4)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1', // Cam sáng
                    'rgba(128, 0, 128, 1)',  // Tím đậm
                    'rgba(0, 128, 128, 1)',  // Xanh lục lam
                    'rgba(255, 255, 0, 1)',  // Vàng
                    'rgba(0, 255, 255, 1)',  // Xanh dương sáng
                    'rgba(128, 128, 128, 1)', // Xám
                    'rgba(240, 248, 255, 1)',
                ],
                borderWidth: 1, // Độ dày viền cột
            },
        ],
    };

    // Tính toán maxSales và làm tròn xuống bội số của 10
    const maxRevenue = Math.max(...categoriesRevenueData.map(item => item.revenue));
    // Làm tròn giá trị lớn nhất lên đến bội số gần nhất (như triệu, nghìn,...)
    const roundedMaxRevenue = Math.ceil(maxRevenue / 100000) * 100000; // Làm tròn lên đến bội số 100000
    // Tính stepSize sao cho có khoảng 10 giá trị trên trục Y
    const stepSize = Math.ceil(roundedMaxRevenue / 9 / 1000) * 1000; // Làm tròn bước nhảy lên bội số của 1000
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                display: false, 
            },
            legend: {
                display: false, // Ẩn legend nếu không cần thiết
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return tooltipItem.raw.toLocaleString('vi-VN') + ' VNĐ';
                    },
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // Không hiển thị gridlines cho trục X
                },
                title: {
                    display: true,
                    text: 'Thể loại sách',
                    font: {
                        size: 14,
                    },
                },
            },
            y: {
                grid: {
                  display: true, // Không hiển thị gridlines cho trục X
                  color: 'rgba(0, 0, 0, 0.05)'
                },
                title: {
                    display: true,
                    text: 'Doanh thu (VND)',
                    color: "rgb(255, 99, 132)",
                    padding: {
                        bottom: 10,
                    },
                    font: {
                        size: 18,
                    },
                },
                ticks: {
                    stepSize: stepSize, // Đặt stepSize cho trục Y
                    callback: function (value) {
                        // Chuyển đổi giá trị thành dạng rút gọn (K, M)
                        if (value >= 1000000) {
                            return (value / 1000000).toFixed(1) + 'M'; // Triệu
                        } else if (value >= 1000) {
                            return (value / 1000) + 'K'; // Nghìn
                        } else {
                            return value.toLocaleString(); // Hiển thị số nguyên
                        }
                    },
                    maxTicksLimit: 10, // Giới hạn số lượng giá trị trục Y
                },
            },
        },
    };
    return (
        <div
            style={{
                width: "100%",
                height: "300px",
                position: "relative",
                padding: "20px",
                cursor: "pointer",
            }}
        >
            <Bar data={data} options={options} />
        </div>
    );
};

export default CategoryRevenueChart;
